{
  "cancelled": "Canceled",
  "contactLink": {
    "authoriseContactLink": "Authorize Contact Link?"
  },
  "bookingButtons": {
    "addFavourite": "Add Favorite",
    "clearFavourite": "Clear Favorite"
  },
  "price": {
    "taxIncluded": "(Incl. {tax} sales tax)"
  },
  "savedJourneys": {
    "favTitle": "Favorite Journeys",
    "noFavsMessage": "No favorite journeys available",
    "alert": {
      "addHeader": "Favorite this journey?"
    }
  },
  "viewBooking": {
    "netPrice": "Net Price",
    "tax": "Sales Tax",
    "totalPrice": "Total Price"
  }
}
